import React from 'react'

class RepaymentType extends React.Component {
  render() {
    const {
      interestType,
      fixedRepaymentTypeLabel,
      variableRepaymentTypeLabel,
    } = this.props

    return(
      <div>
        {
          (interestType === 'fixed') && (
            <p>{fixedRepaymentTypeLabel}</p>
          )
        }
        {
          (interestType === 'variable') && (
            <p>{variableRepaymentTypeLabel}</p>
          )
        }
      </div>
    )
  }
}

export default RepaymentType
